import { Store } from "../../entity/Store";
import { toDate } from "../../utils/GlobalFunctions";
import { StoreDto } from "../dto/Store.Dto";

export const mapToStore = (storeDto: StoreDto): Store => {
  return {
    id: storeDto.id,
    name: storeDto.name,
    address: storeDto.address,
    phoneNumber: storeDto.phoneNumber,
    subdomain: storeDto.subdomain,
    email: storeDto.email,
    createdAt: storeDto.createdAt ? toDate(storeDto.createdAt) : new Date(),
    updatedAt: storeDto.updatedAt ? toDate(storeDto.updatedAt) : new Date(),
    password: storeDto.password,
    status: storeDto.status,
    users: [],
    storeConfig: storeDto.storeConfig,
    packConfig: {
      ...storeDto.packConfig,
      expiredAt: storeDto.packConfig?.expiredAt
        ? toDate(storeDto.packConfig?.expiredAt)
        : new Date(),
    },
  };
};

export const mapToStores = (storeDto: StoreDto[]): Store[] => {
  return storeDto.map((storeDto) => {
    return {
      id: storeDto.id,
      name: storeDto.name,
      address: storeDto.address,
      phoneNumber: storeDto.phoneNumber,
      subdomain: storeDto.subdomain,
      email: storeDto.email,
      createdAt: storeDto.createdAt ? toDate(storeDto.createdAt) : new Date(),
      updatedAt: storeDto.updatedAt ? toDate(storeDto.updatedAt) : new Date(),
      password: storeDto.password,
      status: storeDto.status,
      users: [],
      storeConfig: storeDto.storeConfig,
      packConfig: {
        ...storeDto.packConfig,
        expiredAt: storeDto.packConfig?.expiredAt
          ? toDate(storeDto.packConfig?.expiredAt)
          : new Date(),
      },
    };
  });
};

export const mapToCreatedStore = (store: Store, id: string): Store => {
  return {
    ...store,
    id: id,
  };
};
